import { Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink, MessageSquareHeart } from 'lucide-react';
import InactivityTimer from '../../components/InactivityTimer';

const FEEDBACK_URL = 'https://feedback.kimsbbsr.co.in/feedback/qr-feedback';

const Feedback = () => (
    <>
        <InactivityTimer />
        <main className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-10">
            <div className="w-full max-w-xl rounded-2xl bg-white p-6 text-center shadow-lg sm:p-10">
                <div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-50 text-[#0FA968]">
                    <MessageSquareHeart className="h-10 w-10" />
                </div>
                <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">Patient Feedback</h1>
                <p className="mx-auto mt-3 max-w-md text-gray-600">
                    Your feedback helps us improve our services and patient experience.
                </p>

                <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
                    <Link
                        to="/dashboard"
                        className="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 px-5 py-3 font-semibold text-gray-700 hover:bg-gray-50"
                    >
                        <ArrowLeft className="h-5 w-5" />
                        Back
                    </Link>
                    <a
                        href={FEEDBACK_URL}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center justify-center gap-2 rounded-lg bg-[#0FA968] px-5 py-3 font-semibold text-white hover:bg-[#138F5E]"
                    >
                        Open Feedback Form
                        <ExternalLink className="h-5 w-5" />
                    </a>
                </div>
            </div>
        </main>
    </>
);

export default Feedback;
